export default class Blog {
    /**
     *
     * @param {object} options
     */
    constructor(options) {
        const _defaults = {
            postWrapper: ".js-filter-main-wrapper",
            paginationWrapper: ".js-pagination-wrapper",
            paginationItem: ".js-pagination-item",
            filter: ".js-filter",
            activePaginationItem: ".js-pagination-item.is-active",
            //filterList: ".js-blog-filter-list",
            paginationArrow: ".js-pagination-arrow",
            categorySelect: ".js-category-select",

            postItem: ".js-post-item",

            paginationLoader: ".js-pagination-loader",
            paginationLine: ".js-pagination-loader-line",

        };

        this.defaults = Object.assign({}, _defaults, options);

        this.category = '';
        
        this.init();
    }

    get categorySelect() {
        return document.querySelector(this.defaults.categorySelect);
    }
    
    get activePaginationItem() {
        return document.querySelector(this.defaults.activePaginationItem);
    }

    get paginationItems() {
        return document.querySelectorAll(this.defaults.paginationItem);
    }

    get blogPaginationWrapper() {
        return document.querySelector(this.defaults.paginationWrapper);
    }

    get postWrapper() {
        return document.querySelector(this.defaults.postWrapper);
    }
    
    get body() {
        return document.getElementsByTagName("body")[0];
    }
    
    //endregion

    init() {
        // console.log("PostFilter init()");

        if(this.categorySelect) {
            this.categorySelect.addEventListener("change", (event) => {
                event.preventDefault();

                this.disableFilter();

                const url = this.postWrapper.getAttribute("data-url");

                let page = 1;

                this.category = event.target.value;


                this.ajaxCall(page, this.category, url);
            });
        }


        if (this.blogPaginationWrapper !== null) {
            this.blogPaginationWrapper.addEventListener("click", (event) => {
                if (
                    event.target.closest(this.defaults.paginationItem) &&
                    !this.isFilterInProgress()
                ) {
                    this.handlePaginationItem(event);
                }
            });
        }
    }

    fadeOutPosts() {
        // console.log("fadeOutPosts()");


    }

    fadeInPosts() {
        // console.log("fadeInPosts()");


    }

    handlePaginationItem(event) {
        event.preventDefault();
        this.disableFilter();

        const url = this.postWrapper.getAttribute("data-url");

        //console.log(url);


        const paginationItem = event.target.closest(
            this.defaults.paginationItem,
        );

        let page = 1;

        if (paginationItem.getAttribute("data-type") === "arrow") {
            const side = parseInt(paginationItem.getAttribute("data-side"));
            const max = parseInt(paginationItem.getAttribute("data-max"));
            const current = parseInt(
                paginationItem.getAttribute("data-current"),
            );

            page = current + side;

            if (page < 1 || page > max) {
                this.enableFilter();
                return;
            }
        } else {
            page = paginationItem.getAttribute("data-page");
        }

        const categoryPage = this.postWrapper.getAttribute("data-category");

        //console.log(categoryPage);
        this.isCategory = 0;
        if(categoryPage) {
            this.category = categoryPage;

            this.isCategory = 1;
        }

        //console.log(this.isCategory);

        this.ajaxCall(page, this.category, url, this.isCategory);
    }

    ajaxCall(page, category, url, isCategory) {
        //this.fadeOutPosts();

        const apiUrl = document.querySelector('body').getAttribute('data-api-url');
        let xhr = new XMLHttpRequest();

        let params = "?page=" + page;

        if (category) {
            params += "&category=" + category;
        }


        if(isCategory) {
            params += "&isCategory=" + isCategory;
        }
        //console.log(params);

        xhr.onload = () => {
            // Process our return data
            if (xhr.status >= 200 && xhr.status < 300) {
                // What do when the request is successful
                // console.log("success!", xhr);

                this.afterAjax(xhr.response, page);
            } else {
                // What do when the request fails
                // console.log("The request failed!");
                //console.log('The request failed!');
            }
        };

        xhr.open("GET", apiUrl + "/" + url + params);
        xhr.send();
    }

    afterAjax(response, page) {
         //console.log(response);
        let data = JSON.parse(response);

        this.postWrapper.innerHTML = data.posts;
        this.blogPaginationWrapper.innerHTML = data.pagination;

        this.updateUrls(data.url);

        if (this.paginationItems.length > 0) {
            this.paginationItems.forEach((node) => {
                node.classList.remove("is-active");
            });

            document.getElementById(`${page}`).classList.add("is-active");
        }

        this.fadeInPosts();
        this.enableFilter();
    }
    
    disableFilter() {
        this.body.classList.add("is-filter-disabled");
    }

    enableFilter() {
        this.body.classList.remove("is-filter-disabled");
    }

    isFilterInProgress() {
        return this.hasClass(this.body, "is-filter-disabled");
    }

    updateUrls(url) {
        history.pushState(null, null, url);
    }

    hasClass(element, cls) {
        return (" " + element.className + " ").indexOf(" " + cls + " ") > -1;
    }
}
